import { getInteractionId } from "@atlaskit/react-ufo/interaction-id-context";
import { addCustomData } from "@atlaskit/react-ufo/interaction-metrics";

import { ProductKey } from "@/libraries/signup/bxpkit-core/src/constants";

import {
    SignupUFOExperience,
    ufoEventPaidSignupConfluenceLandingPageLoad,
    ufoEventPaidSignupJSMLandingPageLoad,
    ufoEventPaidSignupJSWLandingPageLoad,
    ufoEventTryCloudSignupPageLoad
} from "./components/signup/utils";

const getProductKeyBundle = () => {
    let productKey = undefined;
    let bundle = undefined;

    try {
        const queryParams = new URLSearchParams(window.location.search);
        productKey = queryParams.get("product") as ProductKey;
        bundle = queryParams.get("bundle") as string;
    } catch (error) {
        console.log(error);
    }

    return { productKey, bundle };
};

export const trackRouteUFOV1PageLoad = (path: string) => {
    const { productKey, bundle } = getProductKeyBundle();

    // Experimental: Route specific UFO V1 page load events
    switch (path) {
        case "try/cloud/signup":
            try {
                const baseData = SignupUFOExperience.BuildCustomBaseData();
                const interactionId = getInteractionId().current;
                if (interactionId) {
                    addCustomData(interactionId, [], baseData);
                }
                ufoEventTryCloudSignupPageLoad.start({ bundle, productKey });
            } catch (error) {
                console.error(error);
            }
            break;
        case "software/jira":
            try {
                ufoEventPaidSignupJSWLandingPageLoad.start({
                    productKey,
                    bundle
                });
            } catch (error) {
                console.error(error);
            }
            break;
        case "software/confluence":
            try {
                ufoEventPaidSignupConfluenceLandingPageLoad.start({
                    productKey,
                    bundle
                });
            } catch (error) {
                console.error(error);
            }
            break;
        case "software/jira/service-management":
            try {
                ufoEventPaidSignupJSMLandingPageLoad.start({
                    productKey,
                    bundle
                });
            } catch (error) {
                console.error(error);
            }
            break;
        default:
            break;
    }
};
